// These form IDs need to be plugged manually to the reload balance inputs on MOBILE
// because the browser will not automatically associate inputs within a modal to a parent form on the other side of the HTML
export const RELOAD_BALANCE_FORM_ID = "reload-balance-form";
export const PURCHASE_FLOW_STEP_1_FORM_ID = "purchase-flow-step-1";